<template><span></span></template>

<script>
import { VueReCaptcha } from "vue-recaptcha-v3";
import Vue from 'vue';
import formMixin from '../../mixins/formMixin';


export default {
    mixins: [formMixin],
    async mounted() {
        if (!this.expectCaptcha) {
            return;
        }

        let captchaKey = '';
        if (process.env.NODE_ENV == "stage" || process.env.NODE_ENV == "qa") {
            captchaKey = await import('../../secrets/captcha.json');
        } else {
            captchaKey = await import('../../secrets/captcha-prod.json')
        }

        Vue.use(VueReCaptcha, { siteKey: captchaKey.siteKey });
    }
};
</script>